var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.02,
    y1: 179.8,
    x2: 200.3,
    y2: 179.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.36 179.8 29.36 93.61 80.36 93.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "80.36 179.8 80.36 30.41 135.66 59.85 135.66 177.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "137.1 114.44 188.81 114.44 188.81 179.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.36,
    y1: 112.28,
    x2: 78.92,
    y2: 112.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.36,
    y1: 132.4,
    x2: 78.92,
    y2: 132.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.87,179.08v-23s0-16.52,15.08-16.52c0,0,13.65,1.43,13.65,17.24v22.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.72,
    y1: 71.34,
    x2: 94.72,
    y2: 78.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 71.34,
    x2: 107.65,
    y2: 78.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.14,
    y1: 71.34,
    x2: 119.14,
    y2: 78.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.72,
    y1: 91.46,
    x2: 94.72,
    y2: 98.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 91.46,
    x2: 107.65,
    y2: 98.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.14,
    y1: 91.46,
    x2: 119.14,
    y2: 98.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.72,
    y1: 112.28,
    x2: 94.72,
    y2: 119.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 112.28,
    x2: 107.65,
    y2: 119.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.14,
    y1: 112.28,
    x2: 119.14,
    y2: 119.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.72,
    y1: 133.11,
    x2: 94.72,
    y2: 140.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 133.11,
    x2: 107.65,
    y2: 140.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.14,
    y1: 133.11,
    x2: 119.14,
    y2: 140.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.72,
    y1: 153.94,
    x2: 94.72,
    y2: 161.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 153.94,
    x2: 107.65,
    y2: 161.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.14,
    y1: 153.94,
    x2: 119.14,
    y2: 161.13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrban);
export default __webpack_public_path__ + "static/media/URBAN.b1bf4e0ad980a5729ac025aa8ac5c3ee.svg";
export { ForwardRef as ReactComponent };